<template src="./index.html"></template>
<style src="./style.scss" lang="scss" scoped></style>
<script>
import { mapState, mapGetters } from 'vuex';
import Background from '@/components/Background';
import Navbar from '@/components/Navbar';
import BackButton from '@/components/BackButton';
import TollfreeNumberInput from '@/components/TollfreeNumberInput';
import NumberSearchButton from '@/components/NumberSearchButton';
import SelectedNumber from './components/SelectedNumber';
import LocalNumberInput from '@/components/LocalNumberInput';
import { formatNumber } from '@/utils/numbers';

export default {
  name: 'SelectNumber',
  components: {
    Background,
    Navbar,
    BackButton,
    TollfreeNumberInput,
    NumberSearchButton,
    SelectedNumber,
    LocalNumberInput
  },
  data() {
    return {
      inputValue: this.$route.query.key || '',
      type: this.$route.query.type,
      disabled: false,
      error: '',
      email: '',
      firstName: '',
      loading: false,
      buttonIcon: 'search'
    };
  },
  computed: {
    ...mapState({
      oneSuggestedNumber: (state) => state.onboarding.oneSuggestedNumber,
      suggestedNumbers: (state) => state.onboarding.suggestedNumbers,
      batchIndex: (state) => state.onboarding.batchIndex
    }),

    splicedNumbers() {
      return this.suggestedNumbers.slice(this.batchIndex * 8, (this.batchIndex + 1) * 8);
    },

    title() {
      return this.type === 'tollfree'
        ? 'Get the perfect toll free vanity number'
        : 'Which local area code are you looking for?';
    }
  },
  mounted() {
    if (!this.oneSuggestedNumber) {
      this.onSearch();
    }
  },
  methods: {
    formatNumber,
    async onSearch() {
      clickmagick_cmc.log('e');
      if (!this.disabled) {
        this.buttonIcon = 'loading';
        this.loading = true;
        const t = this.type === 'tollfree_random' ? 'tollfree' : this.type;
        await this.$store.dispatch('onboarding/setSuggestedNumbers', {
          areaCode: t === 'tollfree' ? '833' : this.inputValue,
          type: t,
          key: this.inputValue,
          showRandomIfError: true
        });
        this.type = t;
        this.loading = false;
        this.buttonIcon = 'search';
        const { numberSearchError } = this.$store.state.onboarding;
        if (numberSearchError) {
          this.error = numberSearchError;
        }
      }
    },

    onChange() {
      if (this.type === 'tollfree' || this.type === 'tollfree_random') {
        this.disabled = this.inputValue.length < 3;
      } else if (this.type === 'local') {
        this.disabled = this.inputValue.length !== 3;
      }
      this.error = '';
    },

    async onSelect(num) {
      await this.$store.dispatch('onboarding/setSelectedNumber', num);
      await this.$router.push('/checkout');
    },

    onNewBatch() {
      this.$store.dispatch('onboarding/setBatchIndex');
    }
  }
};
</script>
